import React from "react"
import Button from "@mui/material/Button"
import { alpha } from "@mui/system"
import {
    BUTTON_FONT_FAMILY,
    BUTTON_FONT_WEIGHT,
    BUTTON_LETTER_SPACING,
    CODE_FONT_FAMILY,
    FONT_SIZE_4XS,
    FONT_SIZE_6XS,
    FONT_SIZE_2XS,
    BUTTON_LETTER_SPACING_XWIDE,
} from "../../style/fontSettings"
import { SECONDARY_HIGHLIGHT, MELOGY_TRANSPARENT, MELOGY_BLACK } from "../../style/colors"
import { BUTTON_FONT_WEIGHT_BOLD, BUTTON_LETTER_SPACING_WIDE } from "../../style/fontSettings"
import {
    getButtonColor,
    getButtonHoverColor,
    getButtonActiveColor,
} from "../../util/ButtonUtil"
import styled from "styled-components"

const StyledText = styled.div`
    width: 100%;
    height: 16px;
    font-family: ${BUTTON_FONT_FAMILY};
    font-size:  ${({ createButton }) => createButton ? FONT_SIZE_4XS : FONT_SIZE_6XS};
    font-weight: ${({ createButton }) => createButton ? BUTTON_FONT_WEIGHT_BOLD : BUTTON_FONT_WEIGHT};             
    letter-spacing: ${({ createButton }) => createButton ? BUTTON_LETTER_SPACING_XWIDE : BUTTON_LETTER_SPACING}; 
    /* white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis; */
    text-align: center;
    color: ${({ createButton }) => createButton ? MELOGY_BLACK : "inherit"};
    /* padding-top: 4px; */
`

const IconAndTextContainer = styled.div`
    height: 32px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`

const IconContainer = styled.div`
    /* color: ${MELOGY_BLACK}; */
    color: ${({ createButton }) => createButton ? MELOGY_BLACK : "inherit"};
    height: 16px;
`;


const MelogyButton = ({
    text,
    height,
    width,
    onClick,
    justifyContent,
    fontSize,
    fontFamily,
    fontWeight,
    letterSpacing,
    textTransform,
    isSelected,
    buttonColor,
    icon,
    margin,
    isToggleSidebarButton,
    textAlign,
    createButton,
    background,
}) => {
    const color = getButtonColor(buttonColor, isSelected)
    const colorHover = getButtonHoverColor(buttonColor)
    const colorActive = getButtonActiveColor(buttonColor)
    const [isTouched, setIsTouched] = React.useState(false)

    const mobileColor = isTouched ? colorActive : color
    const mobileBackgroundColor = createButton
        ? (isTouched ? undefined : undefined) // Create button keeps its background
        : isTouched 
            ? (text ? "rgba(0, 0, 0, 0.9)" : alpha(colorHover, 0.3))
            : (text ? "rgba(0, 0, 0, 0.9)" : "rgba(0, 0, 0, 0.9)")

    return (
        <Button
            onClick={onClick}
            onTouchStart={() => setIsTouched(true)}
            onTouchEnd={() => setIsTouched(false)}
            sx={{
                fontFamily: fontFamily || BUTTON_FONT_FAMILY,
                fontSize: fontSize || FONT_SIZE_6XS,
                letterSpacing: letterSpacing || BUTTON_LETTER_SPACING,
                fontWeight: fontWeight || BUTTON_FONT_WEIGHT,
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
                width: width,
                minWidth: width,
                height: 48,
                minHeight: 48,
                color: color,
                background: createButton ? background : undefined,
                backgroundColor: createButton 
                    ? undefined // Use background prop if createButton
                    : text 
                        ? "rgba(0, 0, 0, 0.9)" // Semi-transparent dark background for text buttons
                        : isSelected 
                            ? alpha(colorHover, 0.2) 
                            : "rgba(0, 0, 0, 0.9)", // Semi-transparent dark background for icon buttons
                backdropFilter: createButton ? undefined : "blur(6px)", // Blur effect for better readability (except create button)
                WebkitBackdropFilter: createButton ? undefined : "blur(6px)", // Safari support
                padding: 0,
                margin: margin || 0,
                borderRadius: text ? "4px" : "0", // 4px for buttons with icon and text
                border: 0,
                // borderBottom:
                //     isSelected && text
                //         ? `2px solid ${SECONDARY_HIGHLIGHT}`
                //         : `2px solid ${MELOGY_TRANSPARENT}`,
                textTransform: textTransform || "none",
                transition: "color 0.3s ease, background-color 0.3s ease",

                "& .MuiButton-startIcon": {
                    margin: "0 0 4px 0",
                    width: "16px",
                    minWidth: "16px",
                    height: "16px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                },

                "&:hover": createButton
                    ? {
                          // Create button keeps its gradient background on hover
                          color: color,
                      }
                    : text
                        ? {
                              color: colorHover,
                              backgroundColor: "rgba(0, 0, 0, 0.9)", // Same on hover
                          }
                        : {
                              color: color,
                              backgroundColor: isSelected
                                  ? alpha(colorHover, 0.3)
                                  : "rgba(0, 0, 0, 0.9)", // Same on hover
                          },

                "@media (hover: none)": {
                    color: mobileColor,
                    backgroundColor:
                        isSelected && !text
                            ? alpha(colorHover, 0.2)
                            : mobileBackgroundColor,
                    "&:hover": {
                        color: mobileColor,
                        backgroundColor: mobileBackgroundColor,
                    },
                },

                "&:focus": {
                    outline: "none",
                },
            }}
        >
            <IconAndTextContainer>
            {/* {icon && <div className="MuiButton-startIcon">{icon}</div>} */}
            {icon && 
                <IconContainer 
                    createButton={createButton}
                >
                    {icon}
                </IconContainer>}
            {text && 
                <StyledText 
                    textAlign={textAlign}
                    createButton={createButton}
                >
                    {text}
                </StyledText>
            }
            </IconAndTextContainer>
        </Button>
    )
}

export default MelogyButton
